














import { defineComponent, reactive } from '@vue/composition-api'

import { UserState } from '@/types/store'
import { UserRole } from '@/types/user'
import useVuex from '@/utils/useVuex'

import Layout from '@/components/organisms/common/Layout.vue'
import { NoticeDetail } from '@/components/organisms/notice-edit'

export default defineComponent({
  name: 'NoticeEdit',
  components: { Layout, NoticeDetail },
  setup(props, context) {
    const store = context.root.$store
    const state = reactive({
      user: useVuex<UserState['user']>(
        context,
        () => store.getters['user/user'],
      ),
    })

    return { state, UserRole }
  },
})
